// removed by extract-text-webpack-plugin
module.exports = {"image":"_4-Q-X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RecurringDonations/RecurringDonationsAwarenessBanner.scss
// module id = ./src/components/RecurringDonations/RecurringDonationsAwarenessBanner.scss
// module chunks = 4